export enum RenderType {
  ABSTRACT = 'abstract',
  DEFAULT = 'default',
  STANDALONE = 'standalone',
}
